import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from '../users.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit, OnDestroy {
  public subscriptions: Subscription[] = [];
  public users: any = [];
  public statusMessage = '';
  public isLoading = true;
  public currentPage = 1;
  public pageSize = 10;
  public usersLength = 0;

  constructor(private usersService: UsersService, private router: Router) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      const state = navigation?.extras.state as { data: string };
      this.statusMessage = state.data;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  ngOnInit(): void {
    this.subscriptions = [];
    window.scroll(0, 0);
    this.getUsersLength();
  }

  public onPageChange(page: number): void {
    console.log('Changing page to: ', page);
    this.getUsers(page, this.pageSize);
  }

  private getUsersLength(): void {
    this.subscriptions.push(
      this.usersService.getUsersLength().subscribe(
        (response) => {
          this.usersLength = response[0].length;
          console.log('usersLength: ', this.usersLength);
          this.getUsers(this.currentPage, this.pageSize);
          console.log(this.users);
        },
        (err) => {
          console.log(err);
          this.isLoading = false;
        }
      )
    );
  }

  private getUsers(page: number, pageSize: number): void {
    this.subscriptions.push(
      this.usersService.getUsers(page, pageSize).subscribe(
        (response) => {
          this.users = response;
          console.log('this.users: ', this.users);
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.isLoading = false;
        }
      )
    );
  }

  onDelete(
    userID: string,
    roleDescription: string,
    firstname: string,
    surname: string,
    email: string
  ): void {
    if (
      confirm(
        '¿Está seguro que desea eliminar el ' +
          roleDescription +
          " '" +
          firstname +
          ' ' +
          surname +
          ' (' +
          email +
          ")'?"
      )
    ) {
      console.log('Eliminando...');

      this.subscriptions.push(
        this.usersService.deleteUser(userID).subscribe(
          (response) => {
            console.log('Usuario eliminado con éxito: ', response);
            alert('Usuario/a eliminado con éxito.');
            this.getUsers(this.currentPage, this.pageSize);
          },
          (error) => {
            console.log('Error al eliminar usuario: ' + error);
          }
        )
      );
    }
  }
}
